import type { DragEvent, MutableRefObject } from "react";

/**
 * Campaigns-table header drag: grab `<th draggable>`, drop on another header.
 */
export function reportColumnHeaderDragHandlers<T extends string>(
  columnId: T,
  dragFromRef: MutableRefObject<T | null>,
  onReorderColumn: (fromId: T, toId: T) => void,
): {
  draggable: true;
  onDragStart: () => void;
  onDragOver: (event: DragEvent) => void;
  onDrop: () => void;
} {
  return {
    draggable: true,
    onDragStart: () => {
      dragFromRef.current = columnId;
    },
    onDragOver: (event) => {
      event.preventDefault();
    },
    onDrop: () => {
      const from = dragFromRef.current;
      dragFromRef.current = null;
      if (from) onReorderColumn(from, columnId);
    },
  };
}
